<template>
	<div>
		<table class="my_table">
			<tbody>
				<tr v-if="is_edit===true">
					<td colspan="6">
						<el-button class="edit_btn" type="primary" plain size="small" @click="openIntro(list)">填写说明</el-button>
					</td>
				</tr>
				<tr>
					<td colspan="2">选项内容</td>
					<td>占比</td>
					<td>样图</td>
					<td colspan="2">正常比值</td>
				</tr>
				<tr v-for="(item,index) in list.target_list">
					<td colspan="2">{{item.name}}</td>
					<td v-if="is_edit===true"><el-input size="small" style="width: 80px;" type="text" v-model="rates[item.id]"></el-input>%</td>
					<td v-if="is_edit===false">{{rates[item.id]}}%</td>
					<td v-if="is_edit===true">
						<el-upload :action="uploadAction" list-type="picture-card" :headers="myHeaders"
							 :on-success="(value)=> handleSuccess(item.id, value)" :file-list="fileList[item.id]"
							:on-remove="(value)=> handleRemove(item.id, value)" :before-upload="beforeUpload">
							<div  >立即上传</div>
						</el-upload>
					</td>
					<td v-else>
					
							<span  v-for="(item,index) in images[item.id]" style="width: 100px;height: 100px;"><el-image :src="item" style="width: 100px;height: 100px;"></el-image>&nbsp;</span>
						
					</td>
					<td :rowspan="rowspan"  v-if="index==0">{{average}}%</td>
					

				</tr>


			</tbody>
		</table>
		<el-dialog :visible.sync="dialogIntroVisible">
			 
			 文字说明 :{{intro_text}}
			    <el-divider content-position="right"></el-divider>
			<el-link :href="item" target="_blank" v-for="(item,index) in intro_images_list" v-if="item!=''" :key="index"><img width="100px" height="100px" :src="item" alt="" ></el-link>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		name: "CollectBase",

		props: {
			work_task_id: {
				type: Number,
				default: 0
			},
			is_edit: {
				type: Boolean,
				default: false
			},
			list: {
				type: Object,
				default: () => []
			},

		},

		created() {
			let average=0
			this.list.target_list.forEach((item,index)=>{
			    this.rates[item.id]=item.target.rates
				this.images[item.id]=item.target.images
				this.fileList[item.id]=[]
				if(item.is_normal==1){
					average=parseFloat(average)+parseFloat(item.target.rates)
				}
				item.target.images.forEach((val,key)=>{
					this.fileList[item.id].push({url:val})
				})
				this.rowspan=this.list.target_list.length
				
			})
			console.log(average);
			this.average=average
		},
		data() {
			return {
				uploadAction: axios.defaults.baseURL + "/upload/image",
				myHeaders: {
					authorization: "Bear " + localStorage.getItem("token")
				},
					 average:'',
				rowspan:0,
				rates:[],
				images:[],
				fileList:[],
				dialogIntroVisible:false,
				intro_text:'',
				intro_images_list:'',
			}
		},
		methods:{
			openIntro(list){
				this.dialogIntroVisible=true
				this.intro_text=list.remark
				this.intro_images_list=list.images
			},
			handleSuccess(id,response, file, fileList) {
				console.log(response.data)
				console.log(this.images)
				this.images[id].push(response.data)
				
				this.fileList[id].push({url:response.data})
			//	console.log(id)
				//
				//console.log(this.images)
				
				///console.log(this.fileList)
			},
			handleRemove(id,file, fileList) {
			
				if (this.action == 1) {
					var url = file.response.data;
				} else {
					var url = file.url;
				}
				var index = this.images[id].indexOf(url)
				this.images[id].splice(index, 1);;
				//this.fileList[id].splice(index, 1);;
			},
			beforeUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPng = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				if (!isJPG && !isPng) {
			
					this.$message.error('上传图片只能是 JPG或PNG 格式!');
					return false
				} else {
					return true
				}
			},
		}
	}
</script>

<style>
	.crop{
	    width: 90px;
	    height: 90px;
	    position: relative;
	    &:before{
	        content: '';
	        width: 40px;
	        height: 37px;
	        background: url("../../assets/images/upLoad_03.png") no-repeat;
	        background-size: cover;
	        position: absolute;
	        top: 50%;
	        left: 50%;
	        margin-left: -20px;
	        margin-top: -18.5px;
	        z-index: 1;
	    }
	    &:after{
	        content: '';
	        width: 30px;
	        height: 30px;
	        background: url("../../assets/images/upLoad_01.png") no-repeat;
	        background-size: cover;
	        position: absolute;
	        top: 50%;
	        left: 50%;
	        margin-left: -15px;
	        margin-top: -15px;
	        z-index: 2;
	    }
	    img{
	        width: 100%;
	    }
	}
</style>
